import TrendingIcon from '@/app/icons/trending'
import { HeaderRow } from '@/components/sections'
import { SearchContext } from '@giphy/react-components'
import { useRouter } from 'next/navigation'
import { useContext } from 'react'
import styled from 'styled-components'
import { CY_SEARCH_BAR__TRENDING_SEARCH } from 'ui/src/utils/cy-test'
import { useTrendingSearches } from '../../../api/hooks'
import DropdownPingback from './dropdown-pingback'

const Item = styled.div`
    display: flex;
    padding: 10px;
    font-style: italic;
    font-weight: 600;
    align-items: center;
`

const Copy = styled.div`
    margin-left: 10px;
`

const TrendingSearches = () => {
    const { term } = useContext(SearchContext)
    const router = useRouter()
    const { data } = useTrendingSearches(term, { limit: 5 })
    return data ? (
        <>
            <HeaderRow className="mt-2">
                <h4 className="text-giphyWhite">Trending Searches</h4>
            </HeaderRow>
            {data.data.slice(0, 5).map(({ name, analytics_response_payload }) => {
                return (
                    <DropdownPingback
                        key={name}
                        arp={analytics_response_payload}
                        responseId={data.meta.response_id}
                        eventType="DROPDOWN_TRENDING_SUGGEST"
                        onClick={() => {
                            router.push(`/search/${encodeURIComponent(name.replace(/ /g, '-'))}`)
                        }}
                    >
                        <Item className={CY_SEARCH_BAR__TRENDING_SEARCH} key={name}>
                            <TrendingIcon className="size-5" />
                            <Copy>{name}</Copy>
                        </Item>
                    </DropdownPingback>
                )
            })}
        </>
    ) : null
}
export default TrendingSearches
